// @flow
import { isRoutingAnchor } from '../lib/urlAndLink';
import { resolveExecute } from './partialUpdate';
import { getParentPartialUpdateContainer } from './partialUpdateUtils';
import type PartialUpdateSettings from './PartialUpdateSettings';

/**
  Automaticky nabinduje partial update na všechny odkazy
  Pokud odkaz odpavídá kritériím, že se jedná o odkay webu a je uvnitř partial updatu
*/
export default (settings: PartialUpdateSettings): void => {
  document.addEventListener('click', (e) => {
    if (!e.defaultPrevented) {
      const closestHrefElement = e.target.closest('a');
      if (closestHrefElement) {
        if (
          isRoutingAnchor(closestHrefElement) &&
          getParentPartialUpdateContainer(closestHrefElement) != null
        ) {
          e.preventDefault();
          resolveExecute(closestHrefElement, settings);
        }
      }
    }
  });
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/partialUpdate/connectLinksListeners.js